<template>
    <div class="table-layout">
        <el-table :data="staffList" border style="width: 100%">
            <el-table-column prop="name" label="员工姓名" width="150"></el-table-column>
            <el-table-column prop="no" width="110" label="员工编号"></el-table-column>
            <el-table-column prop="phoneNo" label="员工手机号"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'
    //
    import servicerApi from '../../api/servicer'
    //
    export default {
        name: 'swb-com-role-ref-staff-list',
        desc: '公司岗位人员列表',
        props: {
            roleId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                staffList: []
            }
        },
        created: function () {
            this.getComRoleRefStaffList();
        },
        methods: {
            getComRoleRefStaffList: function () {
                let self = this;
                servicerApi.getComRoleRefStaffList({roleId: this.roleId}, function (result) {
                    if (result.type == 'info') {
                        self.staffList = result.data || [];
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/authx/ComRoleStaffList.vue